import "./App.css";
import React, { Component, useEffect } from "react";
import axios from 'axios';
import { BrowserRouter as Router, Route, Switch, Redirect, useHistory } from "react-router-dom";

import Notification from './firebaseNotifications/Notification'

import AppointmentComponent from "./component/Appointments/AppointmentsMaster";
import ReportComponent from "./component/Appointments/Report";
import ReportViewComponent from "./component/Appointments/ReportView";
import PrescriptionComponent from "./component/Appointments/Prescription";
import ReferralComponent from "./component/Appointments/Referral";
import UploadReportComponent from "./component/Appointments/UploadReport";
import QueueComponent from "./component/Queue/QueueMaster";
import AppointmentDetailsComponent from "./component/Appointments/AppointmentsDetails";
import HealthMetricsComponent from "./component/Appointments/HealthMetrics";
import CollateralsComponent from "./component/Collaterals/CollateralsMaster";
import AdvertisementBookingComponent from "./component/Advertisement_Booking/AdvertisementBookingMaster";
import AdvertisementBookingListComponent from "./component/Advertisement_Booking/AdvertisementBookingList";
import AdvertisementBookingEditComponent from "./component/Advertisement_Booking/AdvertisementBookingEdit";
import AvailabilityComponent from "./component/Availability/AvailabilityMaster";
import AvailabilitySlotsComponent from "./component/Availability/AvailabilitySlots";
import CancelledAppointmentsComponent from "./component/Cancelled_Appoinments/CancelledAppoinmentsMaster";
import DealComponent from "./component/Deals/DealsMaster";
import ManageServiceComponent from "./component/Manage_Service/ManageServiceMaster";
import ManageAddServiceComponent from "./component/Manage_Service/AddService";
import EditService from "./component/Manage_Service/EditService";
import NotificationComponent from "./component/Notification/Notification";
import ProfileComponent from "./component/Profile/Profile";
import WalkInBookingComponent from "./component/Walkin_Booking/WalkinBookingMaster";
import WorkingHoursComponent from "./component/Working_Hours/WorkingHoursMaster";
import RevenueComponent from "./component/Revenue/RevenueMaster";
import PostComponent from "./component/Post/PostMaster";
import ReviewsListComponent from "./component/Reviews/ReviewsList";
import DashboardComponent from "./component/Layout/Dashboard";
import Forgot from "./component/Login/Forget";
import Login from "./component/Login/Login";
import ResetPassword from "./component/Login/ResetPassword";
import LayoutComponent from "./component/Layout/LayoutComponent";
import WalletMasterComponent from "./component/Wallet/WalletMaster";
import SupportMasterComponent from "./component/Support/SupportMaster";
import AddSupportComponent from "./component/Support/AddSupport";
import ReplaySupportComponent from "./component/Support/ReplaySupport";
import ViewWorkingHoursComponent from "./component/Working_Hours/ViewWorkingHours";
import EditWorkingHoursComponent from "./component/Working_Hours/EditWorkingHours";
import ReferralMasterComponent from "./component/Referral/ReferralMaster";
import ViewReferralMasterComponent from "./component/Referral/ViewReferral";
import ReferredMeComponent from "./component/Referral/ReferredMe";
import RevenueListComponent from "./component/Revenue/RevenueList";
import RevenueMaster from "./component/Revenue/RevenueMaster";
import RevenueTable from "./component/Revenue_settle/Revenue_Tables/RevenueTable.jsx"
import Duetabel from "./component/Revenue_settle/Revenue_Tables/Revenue_duetabel.jsx";
import SettleMentPage from "./component/Revenue_settle/Revenue_Tables/SettleMent.jsx"
import AdvertisementSuccess from "./component/Advertisement_Booking/AdvertisementSuccess"
import OnlineStatus from "./onlinedecter";
import Axios from "axios";

import Cookies from "js-cookie";

// import AuthWatcher from './auth_watcher.js'

import { initEncryptionSession } from "./encryptionSession";


const API_BASE = import.meta.env.VITE_API_URL || "https://health.orangehealth.online/";
axios.defaults.baseURL = API_BASE;
export const apiurl = API_BASE;

// Development Api
// axios.defaults.baseURL = "https://gatewayapi.avelator.in/";
// export const apiurl = "https://gatewayapi.avelator.in/";


export const paymentsuccessurl = window.location.origin + "/dashboard/advertisementbooking/paymentsuccess";
export const kneturl = import.meta.env.VITE_KNET_URL || "https://knettest.theonemoment.com/SendPerformREQuest.php?";
export const decryptKey = import.meta.env.VITE_DECRYPT_KEY || "NX706H5HECB8W336";

const ClearPropsAndRedirect = ({ to, ...rest }) => {
  const { Component, ...props } = rest;
  return (<Route {...props} render={() => <Redirect to={to} />} />);
};


let isLoggingOut = false;
export async function logout(history) {
  if (isLoggingOut) return;
  isLoggingOut = true;

  try {
    const token = Cookies.get("tokenHeader");

    if (token) {
      await axios.post(
        "admin/logout",
        {
          userId: Cookies.get('Doctor_id'),
          reason: "DOCTOR USER LOGOUT FOR THE TIME EXIPRED"
        },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
    }
  } catch (err) {
    // Ignore API errors during logout
    console.warn("Logout API failed:", err?.message);
  } finally {
    // 🧹 Clear cookies
    Object.keys(Cookies.get()).forEach((c) => Cookies.remove(c));

    // 🚀 Navigate to login WITHOUT refresh
    if (history) {
      history.replace("/");
    } else {
      window.location.replace("/");
    }
  }
}
// Hook to provide history to Axios
export function useAxiosInterceptor() {
  const history = useHistory();

  useEffect(() => {
    const publicUrls = [
      "doctor/LoginWeb",
      "doctor/ForgotPassword",
      "doctor/ResetPassword",
      "admin/logout",          // 🚫 do NOT intercept logout
      "admin/create-session",
      "admin/clearVendorWebToken",
      "admin/getvendorprofile"
    ];

    // REQUEST INTERCEPTOR
    const reqInterceptor = axios.interceptors.request.use(
      (config) => {
        if (publicUrls.some((url) => config.url.includes(url))) {
          return config;
        }

        const token = Cookies.get("tokenHeader");
        const tokenExpiry = Cookies.get("tokenExpiry");

        if (!token || !tokenExpiry || new Date(tokenExpiry) <= new Date()) {
          logout(history);
          return Promise.reject("Token expired");
        }

        // ✅ Attach JWT
        config.headers.Authorization = `Bearer ${token}`;
        return config;
      },
      (error) => Promise.reject(error)
    );

    // RESPONSE INTERCEPTOR
    const resInterceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401) {
          logout(history);
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.request.eject(reqInterceptor);
      axios.interceptors.response.eject(resInterceptor);
    };
  }, [history]);
}

// ------------------ PROTECTED ROUTE ------------------
const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      Cookies.get("Doctor_id") ? <Component {...props} /> : <Redirect to="/" />
    }
  />
);

// ------------------ AUTH WATCHER ------------------
function AuthWatcher({ history }) {
  useEffect(() => {
    const publicRoutes = ["/", "/forgot"];

    const path = window.location.pathname;
    const isPublic = publicRoutes.includes(path) || path.startsWith("/ResetPassword");
    if (isPublic) return;

    const tokenExpiry = Cookies.get("tokenExpiry");
    if (!tokenExpiry || new Date(tokenExpiry) < new Date()) {
      logout(history);
      return;
    }

    // Logout automatically when token expires
    const remainingTime = new Date(tokenExpiry) - new Date();
    const timer = setTimeout(() => logout(history), remainingTime);

    return () => clearTimeout(timer);
  }, [history]);

  return null;
}

import MainLayout from "./component/Layout/MainLayout";

// ------------------ MAIN APP ------------------
function App() {
  const history = useHistory();
  useAxiosInterceptor();
  useEffect(() => {
    initEncryptionSession().catch(console.error);
  }, []);

  return (
    <Router>
      <OnlineStatus />
      {/* <AuthWatcher history={history} /> */}

      <Switch>
        {/* PUBLIC ROUTES */}
        <Route exact path="/" component={Login} />
        <Route exact path="/forgot" component={Forgot} />
        <Route exact path="/ResetPassword/:uuid" component={ResetPassword} />

        {/* DASHBOARD ROUTES WRAPPED IN MAINLAYOUT */}
        <Route
          path="/dashboard"
          render={() => (
            <MainLayout>
              <Switch>
                <PrivateRoute exact path="/dashboard" component={DashboardComponent} />
                <PrivateRoute exact path="/dashboard/appointments" component={AppointmentComponent} />
                {/* <PrivateRoute exact path="/dashboard/appointments/referral" component={ReferralComponent} /> */}
                <PrivateRoute exact path="/dashboard/appointments/prescription/:patientId/:bookingId/:date/:is_send_to_pharam/:frompage" component={PrescriptionComponent} />
                <PrivateRoute exact path="/dashboard/appointments/report/:patientId/:bookingId/:date" component={ReportComponent} />
                <PrivateRoute exact path="/dashboard/appointments/uploadreport/:patientId/:bookingId/:date/:frompage" component={UploadReportComponent} />
                <PrivateRoute exact path="/dashboard/appointments/reportview/:Id/:Time/:items" component={ReportViewComponent} />
                <PrivateRoute exact path="/dashboard/appointments/details/:id" component={AppointmentDetailsComponent} />
                <PrivateRoute exact path="/dashboard/appointments/healthmetrics/:patientId/:bookingId" component={HealthMetricsComponent} />
                <PrivateRoute exact path="/dashboard/queue" component={QueueComponent} />
                {/* <PrivateRoute exact path="/dashboard/collaterals" component={CollateralsComponent} /> */}
                <PrivateRoute exact path="/dashboard/workinghours" component={ViewWorkingHoursComponent} />
                <PrivateRoute exact path="/dashboard/workinghours/addservice" component={WorkingHoursComponent} />
                <PrivateRoute exact path="/dashboard/workinghours/viewworkinghours" component={ViewWorkingHoursComponent} />
                <PrivateRoute exact path="/dashboard/workinghours/editworkinghours/:workingHoursId" component={EditWorkingHoursComponent} />
                <PrivateRoute exact path="/dashboard/services" component={ManageServiceComponent} />
                <PrivateRoute exact path="/dashboard/services/addservice" component={ManageAddServiceComponent} />
                <PrivateRoute exact path="/dashboard/services/editservice/:serviceId" component={EditService} />
                <PrivateRoute exact path="/dashboard/walkinbooking" component={WalkInBookingComponent} />
                <PrivateRoute exact path="/dashboard/revenue" component={RevenueMaster} />
                <PrivateRoute exact path="/dashboard/reviews" component={ReviewsListComponent} />
                <PrivateRoute exact path="/dashboard/notification" component={NotificationComponent} />
                <PrivateRoute exact path="/dashboard/profile" component={ProfileComponent} />

                <Redirect to="/dashboard" />
              </Switch>
            </MainLayout>
          )}
        />

        {/* FALLBACK */}
        <Redirect to="/" />
      </Switch>


      <Notification />
    </Router>
  );
}
export default App;
